import { catalogSubcategoryService as service } from '@/services/api/catalogSubcategory.service';
import { catalogSubcategoryModel as model } from '@/models/api/catalogSubcategory.model';
import { sharedHelper, alertHelper } from '@/utils';
import i18n from '@/i18n';

export const CATALOG_SUBCATEGORY_MODULE = 'api/catalogSubcategory';
export const GET_ALL_CATALOG_SUBCATEGORY = 'getAllCatalogSubcategory';
export const CREATE_CATALOG_SUBCATEGORY = 'createCatalogSubcategory';
export const GET_CATALOG_SUBCATEGORY = 'getCatalogSubcategory';
export const UPDATE_CATALOG_SUBCATEGORY = 'updateCatalogSubcategory';
export const UPDATE_CATALOG_SUBCATEGORY_STATUS = 'updateCatalogSubcategoryStatus';
export const DELETE_CATALOG_SUBCATEGORY = 'deleteCatalogSubcategory';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 1,
            pageSize: 15,
            lastPage: 1,
            tableRowsCounts: 0,
            total: 0
        }
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true
    }
};

const fail = (commit, error) => {
    commit('failure'); alertHelper.alertError({
        message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error'),
    });
};
export const actions = {
    async [GET_ALL_CATALOG_SUBCATEGORY]({ commit }, { filter }) {
        commit('requesting');
        try {
            const result = await service.getAll(filter);
            commit('listSuccess', result);
            return result;
        }
        catch (error) {
            fail(commit, error);
            return null;
        }
    },
    async [CREATE_CATALOG_SUBCATEGORY]({ commit, dispatch }, { data, filter }) {
        commit('requesting', 'save');
        try {
            const result = await service.store(data); commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.createXSuccess', [i18n.t('module.catalogSubcategory')]) });
            await dispatch(GET_ALL_CATALOG_SUBCATEGORY, { filter }); return result;
        }
        catch (error) {
            fail(commit, error);
            return null;
        }
    },
    async [GET_CATALOG_SUBCATEGORY]({ commit }, { uuid }) {
        commit('requesting', 'detail');
        try {
            const result = await service.show(uuid);
            commit('detailSuccess', result);
            return result;
        }
        catch (error) {
            fail(commit, error);
            return null;
        }
    },
    async [UPDATE_CATALOG_SUBCATEGORY]({ commit, dispatch }, { data, filter }) {
        commit('requesting', 'save');
        try {
            const result = await service.update(data);
            commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.updateXSuccess', [i18n.t('module.catalogSubcategory')]) });
            await dispatch(GET_ALL_CATALOG_SUBCATEGORY, { filter });
            return result;
        }
        catch (error) {
            fail(commit, error);
            return null;
        }
    },
    async [UPDATE_CATALOG_SUBCATEGORY_STATUS]({ commit, dispatch }, { uuid, isActive, filter }) {
        commit('requesting', 'save');
        try {
            const result = await service.updateStatus(uuid, isActive);
            commit('success');
            await dispatch(GET_ALL_CATALOG_SUBCATEGORY, { filter });
            return result;
        }
        catch (error) {
            fail(commit, error);
            return null;
        }
    },
    async [DELETE_CATALOG_SUBCATEGORY]({ commit, dispatch }, { uuid, filter }) {
        commit('requesting', 'save');
        try {
            const result = await service.softDelete(uuid);
            commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.deleteXSuccess', [i18n.t('module.catalogSubcategory')]) });
            await dispatch(GET_ALL_CATALOG_SUBCATEGORY, { filter });
            return result;
        }
        catch (error) {
            fail(commit, error);
            return null;
        }
    },
};
export const mutations = {
    requesting(state, type = 'list') {
        state.status[type] = false;
    },
    listSuccess(state, result) {
        state.list.data = (result?.data || []).map(model);
        state.list.pagination = sharedHelper.apiPaginationAdapter(result?.pagination || {}); state.status.list = true;
    },
    detailSuccess(state, result) {
        const data = result?.data || {};
        state.details = model(data); state.status.detail = true;
    },
    success(state) {
        state.status = {
            list: true,
            detail: true,
            save: true
        };
    },
    failure(state) {
        state.status = {
            list: true,
            detail: true,
            save: true
        };
    },
};
